
import React, { useEffect, useState } from 'react';
import utils from 'utils';
import { UploadFile } from 'meitav-uikit';
import { setDataLayer } from '../../../../../utils/Functions';
import { Parser } from 'html-to-react';

const { UmbracoUtills, rest } = utils;


export default function FileItem({ key, item, fileList, setFileList, disable }) {
  const p = new Parser();

  const fileTypeID = UmbracoUtills.getValueByKey(item, 'fileTypeID');

  const [showSpinner, setShowSpinner] = useState(false);
  const [uploadSucces, setUploadSucces] = useState(fileList[UmbracoUtills.getValueByKey(item, 'fileTypeID')]?.file != null && fileList[UmbracoUtills.getValueByKey(item, 'fileTypeID')]?.file != '' ? true : false);
  const [uploadError, setUploadError] = useState("");

  const handleChange = async (event) => {
    if (!disable) {
      setShowSpinner(true);
      setDataLayer("PM - Upload files", window.location.pathname, "העלאת קבצים", null);
      const formData = new FormData();
      const fileTarget = event.target.files[0];

      formData.append("File", fileTarget);
      formData.append("fileTypeID", fileTypeID);

      try {
        const res = await rest.post('/api/UploadFiles/CheckFile', {
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        //const res ={data: "success"}

        if (res.data.split(":")[0] == "success") {
          const res = await rest.post('/api/UploadFiles/upload', {
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data',
            }
          });
          const action_name = `${res.data.split(":")[0] == "success" ? "בהצלחה" : "לא עלה"
            } סטטוס קובץ`;

          setDataLayer("PM - Upload files", window.location.pathname, "העלאת קבצים", action_name);

          setUploadSucces(true);
          setUploadError("");

          let tmp = { ...fileList }
          tmp[fileTypeID].file = fileTarget;
          //if(isSaved)
          //  tmp[fileTypeID].isChange=true;
          setFileList(tmp);

        } else {
          setUploadSucces(false);
          setUploadError(res.data.split(":")[1]);
        }
      } catch (error) {
        console.error("file: index.js ~ onChangeHandler ~ error", error);
        setShowSpinner(false);
      }
      setShowSpinner(false);
    }
  };

  const deleteFileClick = async () => {
    if (!disable) {
      const action_name = `מחק - ${fileTypeID}`;
      setDataLayer("PM - Upload files", window.location.pathname, "העלאת קבצים", action_name);

      let tmp = { ...fileList }
      tmp[fileTypeID].file = "";
      setFileList(tmp);
      setUploadSucces(false);
      setUploadError("");
    }
  };

  return (
    <div key={fileTypeID}>
      <UploadFile
        size="normal"
        title=''
        uploadSucces={uploadSucces} uploadError={uploadError} showSpinner={showSpinner}
        fileTypeID={UmbracoUtills.getValueByKey(item, 'fileTypeID')}
        iconBtn={`${import.meta.env.VITE_REACT_APP_IMAGE_URL ||
          window.location.origin}/${UmbracoUtills.getValueByKey(item, 'icon')}`}
        textUpload={UmbracoUtills.getValueByKey(item, 'title')}
        textTooltip={p.parse(UmbracoUtills.getValueByKey(item, 'tooltip'))}
        onChange={handleChange}
        deleteFileClick={deleteFileClick}
        disable={disable}
      />
    </div>
  );
}